/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonProposalVoteInfo = {
    VTP: BabylonProposalVoteInfo.VTP;
    AMT: string;
    AMTPER: string;
};

export namespace BabylonProposalVoteInfo {

    export enum VTP {
        YES = 'YES',
        NO = 'NO',
        VETO = 'VETO',
        ABSTAIN = 'ABSTAIN',
    }


}

